import firebase from "firebase/compat";
import _firestore from "@google-cloud/firestore";
import {BaseDocument, BaseRepository, FieldFunctions} from "../base/repository";
import {MessageType} from "../message";

export interface SmsTemplate extends BaseDocument<SmsTemplate> {
    type: MessageType;
    template: string;
    version: number;
}

export class SmsTemplateRepository extends BaseRepository<SmsTemplate> {
    constructor(firestore: firebase.firestore.Firestore | _firestore.Firestore, fieldFunctions?: FieldFunctions) {
        super(firestore, 'sms_templates', fieldFunctions);
    }

    public async findByType(type: MessageType) {
        const res = await this.find({
            where: [
                { field: 'type', operator: '==', value: type },
                { field: 'status', operator: '==', value: 'active' },
            ],
            orderBy: [{ field: 'version', direction: 'desc' }],
            limit: 1,
        });

        return res && res.length > 0 ? res[0] : undefined;
    }
}